// @flow

import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import {
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    LinkedinIcon,
    TwitterShareButton,
    TwitterIcon,
    EmailShareButton,
    EmailIcon
} from 'react-share';
import AdShare from '../../components/AdShare';

import type { AdShareButton } from '../../components/AdShare';

const AdShareElement = (): React.Node => {
    const { __ } = useTranslate();

    const shareUrl: string = window.location.href;
    const buttonSize: number = 40;

    const buttons: AdShareButton[] = [
        {
            title  : 'email',
            render : (
                <EmailShareButton url="" subject={__('pages:ads.share.mail-subject')} body={__('pages:ads.share.mail-body', { url: shareUrl })}>
                    <EmailIcon size={buttonSize} />
                </EmailShareButton>
            )
        },
        {
            title  : 'facebook',
            render : (
                <FacebookShareButton url={shareUrl}>
                    <FacebookIcon size={buttonSize} />
                </FacebookShareButton>
            )
        },
        {
            title  : 'linkedin',
            render : (
                <LinkedinShareButton url={shareUrl}>
                    <LinkedinIcon size={buttonSize} />
                </LinkedinShareButton>
            )
        },
        {
            title  : 'twitter',
            render : (
                <TwitterShareButton url={shareUrl}>
                    <TwitterIcon size={buttonSize} />
                </TwitterShareButton>
            )
        }
    ];

    return <AdShare buttons={buttons} />;
};

export default AdShareElement;
